import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import SEO from "./components/SEO";
import { BookingProvider } from "./context/BookingContext";
import Home from "./pages/Home";
import Diensten from "./pages/Diensten";
import ComputerReparaties from "./pages/ComputerReparaties";
import HulpOpAfstand from "./pages/HulpOpAfstand";
import Contact from "./pages/Contact";
import AdminConnect from "./pages/AdminConnect";
import AdminStats from "./pages/AdminStats";
import AdminCRM from "./pages/AdminCRM";
import BetalingVoltooid from "./pages/BetalingVoltooid";
import ITSupport from "./pages/ITSupport";
import Zakelijk from "./pages/Zakelijk";
import { Toaster } from "./components/ui/toaster";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <SEO />
        <BookingProvider>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/it-support" element={<ITSupport />} />
              <Route path="/zakelijk" element={<Zakelijk />} />
              <Route path="/diensten" element={<Diensten />} />
              <Route path="/computer-reparaties" element={<ComputerReparaties />} />
              <Route path="/hulp-op-afstand" element={<HulpOpAfstand />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/connect" element={<AdminConnect />} />
              <Route path="/admin/stats" element={<AdminStats />} />
              <Route path="/admin/crm" element={<AdminCRM />} />
              <Route path="/betaling-voltooid" element={<BetalingVoltooid />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </BookingProvider>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
